import {Image} from "@mantine/core";
import React from "react";


const PrivatePolicyTwContent = () => {
    return (
        <>
            <div className="text-[20px] leading-[40px] mb-[45px]">
                <div>發行日期：民國108年01月01日</div>
                <div>「財團法人國家實驗研究院科技政策研究與資訊中心」（以下簡稱本中心）全球資訊網為保障您的個人隱私權與資料安全，特別依照「個人資料保護法」之精神，擬定以下隱私保護及網站安全政策，說明對您個人資料的取得、運用及保護方式。</div>
            </div>

            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">一、政策適用範圍：</div>
            <div className="text-[20px] leading-[40px] mb-[45px]">
                <div>以下的隱私保護及網站安全政策，適用於您在本中心相關網站活動時，所涉及的個人資料蒐集、處理與保護，但不適用於在本網站置設之其他網站連結，當您點選連結至其他網站時，適用各該網站的隱私保護及網站安全政策。</div>
            </div>

            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">二、個人資料之蒐集、運用與保護：</div>
            <div className="text-[20px] leading-[40px] mb-[45px] space-y-[45px]">
                <div>當您使用本中心網站服務，您提供的E-mail 及姓名等資料，將僅運用於本中心提供相關服務時使用。
                </div>
                <div>在本中心網站進行瀏覽、查詢…等活動時，網站伺服器會儲存一些相關紀錄，包括您連線的 IP
                    位址、使用時間及所瀏覽的網頁…等資料。本中心僅對全體使用者的行為總和進行分析，並不會對個別使用者進行分析。
                </div>
                <div>本中心有義務保護您的隱私，絕不會任意出售、交換或出租任何你的個人資料給其他團體或個人。但有下列情形者除外：</div>

                <ul className="text-[#8d7f4c] font-bold">
                    <li>A.配合司法單位合法的調查。</li>
                    <li>B.配合相關職權機關依職務需要之調查。</li>
                </ul>
            </div>

            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">三、Cookies 的運用</div>
            <div className="text-[20px] leading-[40px] mb-[45px]">
                <div>Cookies 是伺服器經由瀏覽器與用戶端溝通的一種技術，會在網友的硬碟中儲存一些資訊，將來得以辨識身分，以提供更多不同的個人化服務或作為網站改進的參考。本中心不會將利用
                    Cookies 取得的資料揭露予第三人。您也可以在瀏覽的設定中選擇是否啟動 Cookies 以及對 Cookies
                    的接受程度。但如果選擇拒絕所有的 Cookies，您可能會無法使用部份個人化服務，或是無法參與本中心某些網站活動。
                </div>
            </div>


            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">四、個人資料的修改、保險與風險承擔</div>
            <div className="text-[20px] leading-[40px] mb-[45px]">
                <div>本中心全球資訊網提供方便而迅速的使用介面，以便您能隨時更新或修正過時或錯誤的個人資料，以及新增、停止各項線上服務。用戶註冊成為會員後，可利用個人的會員帳號與密碼隨時修改個人資料並保護個人隱私，若有密碼外洩疑慮，應立即更換或通知本中心服務人員處理，否則責任後果應由個人自負。除了您於本中心網站會員註冊時所登錄的個人資料外，您在其他促銷或公關等活動中所提供的個人資料，不在此修改範圍之內。</div>
            </div>

            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">五、其他網站的連結</div>
            <div className="text-[20px] leading-[40px] mb-[45px]">
                <div>本中心的隱私權保護政策僅適用於本中心的網站。網站上可能含有其他非屬本中心網站或網頁的超連結（hyperlink），以致於網友可能經由本中心全球資訊網連上這些網站。不論這些網站是否有其隱私保護及網站安全政策，或其內容如何，本中心的隱私權保護政策均不適用於這些網站。</div>
            </div>

            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">六、電子報與電子郵件</div>
            <div className="text-[20px] leading-[40px] mb-[45px]">
                <div>網站將在取得您的同意後，傳送會員快訊，並包含一部份商業訊息。除了在該郵件上註明是由本網站發送，也會在該郵件上提供您能隨時停止接收這些資料或電子郵件的方法。</div>
            </div>

            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">七、網站安全措施與規範</div>
            <div className="text-[20px] leading-[40px] mb-[45px] space-y-[45px]">
                <div>任何未經授權而企圖上載或更改本中心所提供的各項服務及相關資訊的行為，都是嚴厲禁止而且可能觸犯法律。為了網站安全的目的和確保各項服務能夠繼續服務所有的網路使用者，本網站提供了以下的安全保護措施：</div>
                <ul className="text-[#8d7f4c] font-bold list-decimal list-inside">
                    <li>使用網路入侵偵測系統，監控網路流量，以確認未經授權而企圖上載或更改、網頁資訊或蓄意破壞者。</li>
                    <li>裝設防火牆防止非法入侵、破壞或竊取資料，以避免網站遭到非法使用，以保障使用者的權益。</li>
                    <li>裝設掃毒軟體，定期掃毒，以提供使用者更安全的網頁瀏覽環境。</li>
                    <li>進行定期掃描，並提供適當的安全防禦措施。</li>
                    <li>每日進行備份作業，將所有資料備份到備援主機。</li>
                    <li>自動接收所有來自相關作業系統廠商或應用程式廠商所寄發的安全維護電子信通知，並依照電子信的建議，安裝適當的修改程式（PATCH）。</li>
                </ul>

                <div>網際網路資料的傳輸不能保證百分之百的安全，本中心網站將努力保護您的個人資料安全，部分情況下會使用通行標準的
                    SSL
                    加密保全系統，保障資料傳送的安全性。但由於資料傳輸過程牽涉您上網環境保全之良窳，我們並無法確保您傳送或接收本中心網站資料的安全，您須注意並承擔網路資料傳輸之風險。請您諒解此部份所造成的後果均非本中心網站所能控制範圍。
                </div>

            </div>

            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">八、隱私保護條款及安全政策的修改</div>
            <div className="text-[20px] leading-[40px] mb-[45px]">
                <div>由於科技發展的迅速，相關法規訂定未臻完備前，以及未來可能難以預見的環境變遷等因素，本中心將會視需要修改網站上所提供的隱私保護及安全政策的說明，以落實保障您隱私權及網路安全的立意。當本中心完成隱私保護條款及安全政策的修改時，我們會立即將其刊登於網站，並以醒目標示提醒您前往點選閱讀。
                    如果您對以上條款有任何疑問或意見，歡迎來信至 <a className="text-blue-700 underline px-2" href="mailto:privacy.stpi@niar.org.tw">privacy.stpi@niar.org.tw</a>。
                </div>
            </div>
        </>
    );
}

export default PrivatePolicyTwContent;